import { render, staticRenderFns } from "./ArchiveWorkspaces.vue?vue&type=template&id=9645ccde&"
import script from "./ArchiveWorkspaces.vue?vue&type=script&lang=js&"
export * from "./ArchiveWorkspaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports